import { Controller } from "stimulus";
import { submitForm } from "init/ajax";
import { closeModal } from "../modal/utils";

export default class extends Controller {
  static targets = ["toggleTitle", "form"];

  connect() {
    this.originalForm = this.formTarget.innerHTML;
  }

  validate() {
    let valid = true;
    let requiredFields = this.formTarget.querySelectorAll("[required]");

    requiredFields.forEach(field => {
      let error_msg = field.parentNode.querySelector(".error-msg");
      if (field.checkValidity()) {
        field.parentNode.classList.remove("error");
        if (error_msg) field.parentNode.removeChild(error_msg);
      } else {
        let parent = field.parentNode;
        let child = error_msg ? error_msg : document.createElement("span");
        let msg = field.validationMessage;
        child.classList.add("error-msg");
        child.innerText = msg;
        parent.classList.add("error");
        parent.appendChild(child);
        valid = false;
      }
    });

    return valid;
  }

  submit(e) {
    e.preventDefault();
    e.returnValue = false;
    let valid = this.validate();
    if (!valid) {
      return;
    } else {
      submitForm(this.formTarget).then(response => {
        if (response.success == "true") {
          let $this = this;
          this.element.classList.add("success");
          this.formTarget.innerHTML = this.originalForm;
          setTimeout(() => {
            $this.element.classList.remove("success");
            closeModal($this);
          }, 5000);
        } else {
          closeModal(this.element);
        }
      });
    }
  }

  toggleAddons = () => this.toggleTitleTarget.classList.toggle("open");
}
